export default __webpack_public_path__ + "static/media/Conectividade (Real Size).e0181155.svg";